export default "__VITE_ASSET__bO5$8QrP__"